/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountCreateRequest } from '../models/AccountCreateRequest';
import type { AccountResponse } from '../models/AccountResponse';
import type { AccountUpdateRequest } from '../models/AccountUpdateRequest';
import type { PaginatedResponse } from '../models/PaginatedResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AccountService {
    /**
     * Create Account
     * 사용자 계정 생성
     *
     * 새로운 사용자 계정을 생성합니다.
     * @returns AccountResponse Created
     * @throws ApiError
     */
    public static appsAccountViewsCreateAccount({
        requestBody,
    }: {
        requestBody: AccountCreateRequest,
    }): CancelablePromise<AccountResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Current Account
     * 현재 인증된 사용자 계정 조회
     *
     * 요청한 사용자의 계정 정보를 반환합니다.
     * @returns AccountResponse OK
     * @throws ApiError
     */
    public static appsAccountViewsGetCurrentAccount(): CancelablePromise<AccountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/account',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get Account
     * 사용자 계정 조회
     *
     * ID로 특정 사용자 계정을 조회합니다.
     * @returns AccountResponse OK
     * @throws ApiError
     */
    public static appsAccountViewsGetAccount({
        accountId,
    }: {
        accountId: string,
    }): CancelablePromise<AccountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/account/{account_id}',
            path: {
                'account_id': accountId,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Account
     * 사용자 계정 정보 수정
     *
     * 특정 사용자 계정의 정보를 수정합니다.
     *
     * ⚠️ **권한 필요**: 본인 계정만 수정할 수 있습니다.
     * - 다른 사용자의 계정 수정 시도 시 403 Forbidden 응답이 반환됩니다.
     * @returns AccountResponse OK
     * @throws ApiError
     */
    public static appsAccountViewsUpdateAccount({
        accountId,
        requestBody,
    }: {
        accountId: string,
        requestBody: AccountUpdateRequest,
    }): CancelablePromise<AccountResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/account/{account_id}',
            path: {
                'account_id': accountId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Account
     * 사용자 계정 삭제
     *
     * 특정 사용자 계정을 삭제합니다. (소프트 삭제)
     *
     * ⚠️ **권한 필요**: 본인 계정만 삭제할 수 있습니다.
     * - 다른 사용자의 계정 삭제 시도 시 403 Forbidden 응답이 반환됩니다.
     * @returns void
     * @throws ApiError
     */
    public static appsAccountViewsDeleteAccount({
        accountId,
    }: {
        accountId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/account/{account_id}',
            path: {
                'account_id': accountId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Accounts
     * 사용자 계정 목록 조회 및 검색
     *
     * 사용자 계정을 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * q: 검색 키워드 (선택사항) - 이름, 이메일로 검색
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 100)
     * @returns PaginatedResponse OK
     * @throws ApiError
     */
    public static appsAccountViewsListAccounts({
        q,
        page = 1,
        perPage = 100,
    }: {
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/account/list',
            query: {
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
}
